import 'babel-polyfill'

import Vue from 'vue'
import vuetify from './plugins/vuetify';

import axios from './axios'
import router from './router'

import App from './App.vue'

import moment from 'moment'
import clone from 'clone'
import lodash from 'lodash'

Vue.prototype.$axios = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$clone = clone;
Vue.prototype.$_ = lodash;

Vue.config.productionTip = false;

// import VueTheMask
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask);

// import VCalendar
import VCalendar from 'v-calendar';
Vue.use(VCalendar, {componentPrefix: 'im'});

// import VueGoogleMaps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCu1N9tNE8mEh_u4yI3SCOn3M_gV3CgL5E',
    libraries: 'places',
  },
  installComponents: true,
});


new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');
